import { Navigate } from 'react-router-dom';

// Supplier Pricing has been merged into the Supplier Quotes page.
// Any bookmarked or linked URLs will redirect automatically.
export default function SupplierPricingPage() {
  return <Navigate to="/orders/quotes" replace />;
}
